import {
  ChargeItemDefinitionGetAllParams,
  ChargeItemDefinitionGetAllResponse,
  ChargeItemDefinitionGetResponse,
  CreateChargeItemDefinition,
  CreateChargeItemDefinitionResponse,
  UpdateChargeItemDefinition,
  UpdateChargeItemDefinitionResponse,
} from '@quromedical/models';
import { trpc } from 'trpc';

export class ChargeItemApi {
  public async getChargeItems(
    params: ChargeItemDefinitionGetAllParams
  ): Promise<ChargeItemDefinitionGetAllResponse> {
    return await trpc.client.chargeItemDefinition.getAll.query(params);
  }

  public async getChargeItem(id: string): Promise<ChargeItemDefinitionGetResponse> {
    return await trpc.client.chargeItemDefinition.getById.query({ id });
  }

  public async createChargeItem(
    body: CreateChargeItemDefinition
  ): Promise<CreateChargeItemDefinitionResponse> {
    return await trpc.client.chargeItemDefinition.create.mutate({
      ...body,
    });
  }

  public async updateChargeItem(
    body: UpdateChargeItemDefinition
  ): Promise<UpdateChargeItemDefinitionResponse> {
    return await trpc.client.chargeItemDefinition.update.mutate(body);
  }
}
